import { Controller } from '@hotwired/stimulus';

import { importLibrary, setOptions } from '@googlemaps/js-api-loader';

export default class extends Controller {
  static values = { address: String, apiKey: String, id: String };

  connect() {
    this.getLocation();
  }

  async getLocation() {
    setOptions({ key: this.apiKeyValue });

    const { Map: GoogleMap } = await importLibrary('maps');
    const { Geocoder } = await importLibrary('geocoding');
    const { AdvancedMarkerElement } = await importLibrary('marker');

    const geocoder = new Geocoder();
    const map = new GoogleMap(this.element, { center: { lat: 0, lng: 0 }, mapId: this.idValue });

    geocoder.geocode({ address: this.addressValue }, (results, status) => {
      if (status === 'OK') {
        const location = results[0].geometry.location;

        map.setCenter(location);
        map.fitBounds(results[0].geometry.viewport);

        new AdvancedMarkerElement({ map, position: location });
      }
    });
  }
}
